import React from 'react';
import { Star } from '@phosphor-icons/react';

const testimonials = [
  [
    'Coffee',
    'Saumya Mishra',
    'It was a last minute booking but the team handled it amazingly. They took Coffee for swimming for the 1st time and took such great care of him while I was travelling. They keep sharing videos periodically — so nice of them.',
    'https://images.unsplash.com/photo-1561037404-61cd46aa615b?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Jacky',
    'Sthiti Sarangi',
    'I have been dropping my GSD Jacky every time I go out of station. Petcart Nest really knows how to take care of pets. Jacky loves the place and enjoys his stay — they send daily videos.',
    'https://images.unsplash.com/photo-1568572933382-74d440642117?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Twookie',
    'Mamata Borthakur',
    'My 10 year old girl Twookie is a regular here. The team is committed and caring, attentive to feedback. It is a joy to see Twookie playing happily in the vast open lawns when I pick her up.',
    'https://images.unsplash.com/photo-1583511655826-05700d52f4d9?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Simba',
    'Indranil Sarkar',
    'I kept Simba at Petcart and I am genuinely impressed with the care they provided — medicines on time, proper attention to his diet, and the owner welcomes you with a smile every visit.',
    'https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Akira',
    'Dhyana Sindhu',
    'We celebrated our pet Akira\'s 2nd birthday at Petcart and it was a total blast. The atmosphere is fantastic and the space is safe for pets to socialize and play in their huge pet park.',
    'https://images.unsplash.com/photo-1517849845537-4d257902454a?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Poco & Biscuit',
    'Vidya Holla',
    'I dropped Poco and Biscuit here for 3 days. Poco was recovering from a surgery wound — the staff changed his bandages on time and made sure he didn\'t lick the wounds. A pleasant stay.',
    'https://images.unsplash.com/photo-1450778869180-41d0601e046e?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Axl & Frodo',
    'Arka Anand',
    'We have been coming to Pet Cart Nest for 7 years — the best place to be with your pets. The doggie pool is clean, the food is amazing. Boarding Frodo and Axl here is always the best experience.',
    'https://images.unsplash.com/photo-1543466835-00a7907e9de1?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Jigar',
    'Manu Madhusudhanan',
    'Been keeping my Lab here whenever I go on vacation. He isn\'t the friendliest kind but he is very comfortable here — the caretakers are great. I drive an hour and a half for this place.',
    'https://images.unsplash.com/photo-1552053831-71594a27632d?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Tango',
    'Mani Vasagan',
    'We had a tough time finding the right place for our naughty rottie. Petcart Nest became the best thing we ever found. He thoroughly enjoys being in their company. Wonderful hosts!',
    'https://images.unsplash.com/photo-1567752881298-894bb81f9379?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Rexy',
    'Porvi Mahajan',
    'My mini poodle spent a week at PetCart. Shekhar sent photos and videos every single day, without even asking. Loved their setup, cleanliness and the way they maintain the place. Rexy was having a great time.',
    'https://images.unsplash.com/photo-1582456891925-a53d52fc91ab?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Lexi',
    'Jithendran PK',
    'I have been using this pet care center for my dachshund for quite some time, and I am consistently impressed. Whenever I travel I can rely on them with utmost attention and affection.',
    'https://images.unsplash.com/photo-1612536057832-2ff7ead58194?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Akira',
    'Rajasekhar Mandadi',
    'We boarded our dog Akira for two days and couldn\'t be happier. The team went out of their way to make her feel comfortable — regular updates, photos and videos. Akira came back happy, healthy and calm.',
    'https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Bella, Basil & Shadow',
    'Dr Balu Krishnan',
    'Wonderful place — they really care for our pets. I have been boarding mine for the last 6 years. Absolutely no worries. Shekhar is very passionate about his work and cares for ours as his own.',
    'https://images.unsplash.com/photo-1558788353-f76d92427f16?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Sibu',
    'Malathi S',
    'Petcart Nest is our go-to place for Sibu whenever we are away. It is safe, trusted, and he always has a great time playing with his buddies. The swimming pool is his favourite part.',
    'https://images.unsplash.com/photo-1505628346881-b72b27e84530?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Pet-children',
    'Anitha Nathan',
    'Leaving behind three of them was a major concern. Petcart Nest took care of our pet-children well with regular updates and timely play sessions. The owner is understanding, polite and forthcoming.',
    'https://images.unsplash.com/photo-1477884213360-7e9d7dcc1e48?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Neo',
    'Shubham Soin',
    'I left Neo at Petcart Nest for three days and it was amazing. Friendly, caring staff with regular updates. Most importantly, my dog came home happy and relaxed — something I haven\'t seen after other stays.',
    'https://images.unsplash.com/photo-1583511655826-05700d52f4d9?auto=format&fit=crop&w=160&h=160&q=80',
  ],
  [
    'Simba',
    'Nishalina Pathak',
    'A spacious, friendly and safe resort for our furry baby. I have been keeping my GSD Simba since he was 7 months old — 3 years now. They send a daily WhatsApp clip to show us he is doing well.',
    'https://images.unsplash.com/photo-1568572933382-74d440642117?auto=format&fit=crop&w=160&h=160&q=80',
  ],
];

const Testimonials = () => {
  const loop = [...testimonials, ...testimonials];

  return (
    <section className="bg-neutral-950 py-14 text-white sm:py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="landing-section-header">
          <h2 className="landing-section-title--inverse">What Pet Parents Say</h2>
          <p className="landing-section-lede--inverse mx-auto">Stories from our happy pet families</p>
        </div>
      </div>

      <style>{`
        @keyframes testimonialsScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .testimonials-track { animation: testimonialsScroll 120s linear infinite; }
        .testimonials-track:hover { animation-play-state: paused; }
      `}</style>

      <div className="relative overflow-hidden">
        <div className="testimonials-track flex w-max gap-4 px-4">
          {loop.map(([dog, parent, review, avatar], idx) => (
            <article
              key={`${dog}-${idx}`}
              className="w-72 shrink-0 rounded-2xl border border-white/10 bg-neutral-800 p-5"
            >
              <div className="mb-3 flex items-center gap-3">
                <img
                  src={avatar}
                  alt={dog}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-white">{dog}&apos;s Parent</h3>
                  <p className="landing-card-meta--inverse mt-0.5">{parent}</p>
                </div>
                <svg viewBox="0 0 48 48" className="h-6 w-6 shrink-0" aria-label="Google review">
                  <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
                  <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
                  <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
                  <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
                </svg>
              </div>
              <div className="mb-3 flex gap-0.5">
                {[...Array(5)].map((_, index) => (
                  <Star key={index} size={12} weight="fill" className="text-yellow-400" />
                ))}
              </div>
              <p className="text-sm font-normal text-white/85">{`"${review}"`}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
